import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { t } from '@lingui/macro'
import type { GeneralAttendanceRow, TestCountRow, ThresholdAlerts } from '@/core/api/statistics'
import { GeneralAttendanceTable } from './GeneralAttendanceTable'
import { TestsPerformedTable } from './TestsPerformedTable'
import { ThresholdAlertsTable } from './ThresholdAlertsTable'

type Props = {
  isExpanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  generalAttendance: { data?: GeneralAttendanceRow[]; isLoading: boolean; error?: unknown }
  testsPerformed: { data?: TestCountRow[]; isLoading: boolean; error?: unknown }
  thresholdAlerts: { data?: ThresholdAlerts[]; isLoading: boolean; error?: unknown }
  isMobile: boolean
  multiEstablishment: boolean
}

export function GeneralClinicSection({
  isExpanded, onChange, generalAttendance, testsPerformed, thresholdAlerts, isMobile, multiEstablishment,
}: Props) {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: false } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : undefined }}>
          {t`General Clinic`}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: isMobile ? 1 : 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Attendance by gender and age group`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <GeneralAttendanceTable
                data={generalAttendance.data}
                isLoading={generalAttendance.isLoading}
                error={generalAttendance.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Tests performed`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <TestsPerformedTable
                data={testsPerformed.data}
                isLoading={testsPerformed.isLoading}
                error={testsPerformed.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
              {t`Alerts (configurable thresholds)`}
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <ThresholdAlertsTable
                data={thresholdAlerts.data}
                isLoading={thresholdAlerts.isLoading}
                error={thresholdAlerts.error}
                multiEstablishment={multiEstablishment}
              />
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
